import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PermissionEnum, TransactionLogsContent } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemExchangeTransaction from '../hooks/use-exchange';

const ProblemExchangeTransactionLogContentHOC = (): React.JSX.Element => {
  const { transactionId } = useParams();

  const { logs } = useAppSelector(
    (state) => state.customersProblemTransactions.exchange,
  );
  const { activePermissions } = useAppSelector((state) => state.root);

  const { getExchangeLogsAction, logsIsLoading } =
    useProblemExchangeTransaction({ transactionId });

  useEffect(() => {
    if (!logs && transactionId) {
      getExchangeLogsAction();
    }
  }, [getExchangeLogsAction, logs, transactionId]);

  return (
    <TransactionLogsContent
      isLoading={logsIsLoading}
      logs={logs}
      activePermission={activePermissions?.includes(
        PermissionEnum.TRANSACTION_QUEUE_ITEMS_EXCHANGE_LIST,
      )}
    />
  );
};

export default ProblemExchangeTransactionLogContentHOC;
